var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shopify-create-store"},[_c('Guide',{attrs:{"width":"small","content":_vm.content,"contentHeading":"Select/Create An Account","closeLink":_vm.closeLink,"nextLink":_vm.nextLink,"previousLink":_vm.previousLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }